import { createEntityAdapter } from '@reduxjs/toolkit';
import { IEppDiameter } from 'application/components/api/EppDiameter';

export const eppDiameterAdapter = createEntityAdapter<IEppDiameter, number>({
  selectId: (project) => project.eppDiameterID,
});
